export const error = {
  generic: 'Es ist ein Fehler aufgetreten. Bitte entschuldigen sie die Unannehmlichkeiten.',
}
